import { useQuery } from 'react-query';
import { LiveFeedEvent } from '../domain';
import { apiHttpService } from './apiHttpService';

interface UseEventFeedParams {
  eventId?: string | null;
  searchQuery?: string;
}

export function useEventFeed({
  eventId,
  searchQuery = '',
}: UseEventFeedParams) {
  return useQuery<LiveFeedEvent>(
    ['eventFeed', eventId],
    async () => {
      const { data } = await apiHttpService.get<LiveFeedEvent>(
        `/GetEventFeed?eventId=${eventId}`,
      );
      return data;
    },
    {
      enabled: !!eventId,
      staleTime: Infinity,
      refetchIntervalInBackground: true,
      keepPreviousData: true,
      select: (data) =>
        searchQuery
          ? {
              ...data,
              eventClassList: data.eventClassList.filter(
                (item) =>
                  item.clNumber?.toString().includes(searchQuery) ||
                  item.className
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase()),
              ),
            }
          : data,
    },
  );
}
